<template>
  <div class="TupianList inner_center">

    <!-- 图片，专题，图片包公共部分 -->
    <div v-for="vo in tupianList" :key="vo.id" class="Tupian-item">
            <slot class="TupianItemContentSlot" name="TupianItemContentSlot"></slot>


      <!-- 图片 -->
      <TupianImg :tupian-item="vo"/>

      <!-- 收藏 -->
      <TupianCollectBtn v-if="vo.type != 2 " :tupian-item="vo" @toggleTupianCollect="toggleTupianCollect"/>

      <!-- 图片标签 -->
      <TupianLabel :tupian-item="vo"/>

      <!-- 图片标题: 仅专题展示 -->
      <TupianTitle :tupian-item="vo" v-if="vo.type === 2 || vo.type == 3"/>

      <!-- 图片下载按钮
                     @downloadFree="downloadFree"
                     @download="download"
                     @downloadSourceFiles="downloadSourceFiles"
                     @buyBusinessVip="buyBusinessVip"
                     @buyTupianPackage="buyTupianPackage"
                     @downloadTupianPackage="downloadTupianPackage"
                     @downloadTupianPackageSourceFiles="downloadTupianPackageSourceFiles"
      -->
      <TupianDownBtn :tupian-item="vo" v-if="vo.type == 1 || !vo.type"
                     v-bind="$attrs" v-on="$listeners"
      />

      <i class="icon_help" v-if="vo.isInvite"></i>
    </div>

  </div>
</template>

<script>
import TupianImg from '@/components/tupian/tupian-list/tupian-img';
import TupianCollectBtn from './tupian-collect-btn';
import TupianLabel from '@/components/tupian/tupian-list/tupian-label';
import TupianTitle from '@/components/tupian/tupian-list/tupian-title';
import TupianDownBtn from '@/components/tupian/tupian-list/tupian-down-btn';
import {PAGE_PATH} from '@/constant/PAGE_PATH'
import {fnLogin, fnPay, fnRouter, fnTuPian} from "@/fn";
import {mapState} from "vuex";
import {toggleMaterialCollect} from "@/api/material";
import {toggleTopicCollect} from "@/api/topic";

export default {
  name: "TupianList",
  props: {
    tupianList: {
      type: Array,
      default: () => [],
      require: true
    }
  },
  components: {
    TupianImg,
    TupianCollectBtn,
    TupianLabel,
    TupianTitle,
    TupianDownBtn
  },
  computed: {
    BASE_IMG_Link() {
      return PAGE_PATH.BASE_IMG_URL
    },
    TUPIAN_DETAIL_Link() {
      return fnRouter.getRouterLink(PAGE_PATH.TU_PIAN.DETAIL);
    },
  },
  data() {
    return {
      PAGE_PATH
    }
  },
  methods: {
    toggleTupianCollect(tupianItem) {
      if (fnLogin.checkLogin()) {
        let isCollect = tupianItem.isCollect || false;

        /* 收藏图片 ( 图片和图片包参数不一致 ) */
        if (tupianItem.type == 1 || !tupianItem.type) {
          fnTuPian.collectTupian(tupianItem).then(res => {
            let msg = isCollect === false ? '收藏成功' : '已取消收藏';
            this.$set(tupianItem, 'isCollect', !tupianItem.isCollect)
            this.$myNotify.success(msg);
          })

        }

        /* 收藏专题 */
        if (tupianItem.type == 3) {
          fnTuPian.collectTupianTopic(tupianItem).then(res => {
            let msg = isCollect === false ? '订阅成功' : '已取消订阅';
            this.$set(tupianItem, 'isCollect', !tupianItem.isCollect)
            this.$myNotify.success(msg);
          })
        }

      } else {
        fnLogin.loginIntercept(false);
      }

    },
    download(tupianItem) {

    },
    downloadSourceFiles(tupianItem) {
    },

    buyBusinessVip(tupianItem) {
      fnPay.payTracking('充值:图片包商用购买:图片:click')
      fnRouter.navigationTo(PAGE_PATH.PAY_BUSINESS);
    },

    buyTupianPackage(tupianItem) {
    },

    downloadTupianPackage(tupianItem) {
    },
    downloadTupianPackageSourceFiles(tupianItem) {
    },
  }
}
</script>

<style lang="scss" scoped>
.TupianList {
  display: flex;
  flex-wrap: wrap;

  .Tupian-item {
    width: 336px;
    height: 440px;
    //background: #CCCCCC;
    box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.06);
    border-radius: 14px;
    margin: 0 32px 40px 0;
    position: relative;
    transition: all 0.5s ease-in-out;
    overflow: hidden;
    display: inline-block;
    @include ElementHover('', '') {
      box-shadow: 0px 0px 15px 0px rgba(0, 0, 26, 0.12) !important;

      .icon_help{
        display: none;
      }
    }

    .icon_help{
      @include BgImage(112px,96px,'act/rabbit/icon_help.png');
      @include Position(1,3,0,0);
      z-index: 2;
    }

    &:nth-child(4n) {
      margin-right: 0;
    }

    /deep/ .TupianImg {
      display: inline-block;
      width: 100%;
      height: 100%;
    }

    a {
      display: inline-block;
      width: 100%;
      height: 100%;
      border-radius: 14px;
      position: relative;
      transition: all 0.5s ease-in-out;
      @include ElementHover('', '') {
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 26, 0.12) !important;
      }

      .tupian-img {
        display: inline-block;
        width: 100%;
        height: 100%;
        border-radius: 14px;
        transition: all 0.5s ease-in-out;
        @include ElementHover('', '') {
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 26, 0.12) !important;
        }
      }
    }


    @include ElementHover('', '') {

      .TupianTitle {
        bottom: 0;
      }
      .material-tag {
        top: 16px;
      }
      .collect {
        top: 16px;
      }
      /deep/ .legal-copy-active {
        display: block !important;
      }
      /deep/ .icon_PicTagLegalCopy {
        display: none !important;
      }

      /deep/ .TupianDownBtn {
        bottom: 0;
      }
    }

    .TupianItemContentSlot{
      @include Position(1,5,0,0);
      width: 100%;
      height: 100%;
      pointer-events: none;
      background: transparent;
    }


  }

  @include Screen(1) {
    .Tupian-item {
      width: 279px;
      height: 365px;
      margin: 0 28px 29px 0;
      position: relative;

      .material-title {
        height: 66px;
      }
    }
  }
}
</style>
